const dictionary = {
    searchInput: {
        default: "SZUKAJ WEDŁUG/SEARCH BY",
        data_zdarzenia: 'YYYY-MM-DD',
        data_zakonczenia_badania: 'YYYY-MM-DD',
    }
}

export default function getDictionaryTranslation(type, element) {

    if (!dictionary[type]) return " "

    if (dictionary[type][element]) {
        return dictionary[type][element]
    }

    return dictionary[type]['default']
}